import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";

export const NavSearch = ({ mobile = false, onDone }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(mobile);
  const [q, setQ] = useState("");
  const ref = useRef(null);

  useEffect(() => { if (open && !mobile) ref.current?.focus(); }, [open, mobile]);

  const submit = (e) => {
    e.preventDefault();
    const v = q.trim();
    if (!v) return;
    onDone?.();
    navigate(`/stories?q=${encodeURIComponent(v)}`);
  };

  if (mobile) {
    return (
      <form onSubmit={submit} data-testid="nav-mobile-search-form" className="flex border border-white/20 focus-within:border-[#E30613] transition-colors mb-4">
        <Search size={16} className="self-center ml-3 text-neutral-500" />
        <input data-testid="nav-mobile-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search stories" className="flex-1 bg-transparent px-3 py-3 text-sm outline-none placeholder:text-neutral-600 text-white" />
        <button type="submit" data-testid="nav-mobile-search-submit" className="px-4 text-[10px] uppercase tracking-[0.2em] font-bold text-[#E30613]">Go</button>
      </form>
    );
  }

  return (
    <form onSubmit={submit} data-testid="nav-search-form" className={`flex items-center border transition-[width,border-color] duration-300 h-11 ${open ? "w-56 border-white/60" : "w-11 border-white/20 hover:border-white/60"}`}>
      <button type="button" data-testid="nav-search-toggle" aria-label="Search stories" onClick={() => setOpen((v) => !v)} className="w-11 h-11 shrink-0 inline-flex items-center justify-center text-neutral-300 hover:text-white transition-colors">
        <Search size={17} />
      </button>
      <input
        ref={ref}
        data-testid="nav-search-input"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        onBlur={() => { if (!q) setOpen(false); }}
        placeholder="Search stories"
        className={`bg-transparent text-sm text-white outline-none placeholder:text-neutral-600 transition-opacity duration-200 ${open ? "w-full pr-3 opacity-100" : "w-0 opacity-0 pointer-events-none"}`}
      />
    </form>
  );
};
